import React from 'react';

export type SemiFinishedAdjustmentTotal = {
  semiFinishedProductId: number;
  name: string;
  unit: string;
  quantity: number;
};

export default function SemiFinishedAdjustmentPreview({ totals }: { totals: SemiFinishedAdjustmentTotal[] }) {
  if (!totals.length) return null;
  return (
    <section aria-label="Коригування напівфабрикатів" style={{ padding: '10px 12px', borderTop: '1px solid var(--crm-border)' }}>
      <strong>Напівфабрикати зі складського залишку:</strong>
      <p style={{ margin: '6px 0', fontSize: '12px', color: 'var(--crm-text-muted)' }}>
        Ці кількості також зміняться у ревізії. Вони не входять до підсумку сирих продуктів.
      </p>
      {totals.map(total => (
        <div key={total.semiFinishedProductId} style={{ display: 'flex', gap: '12px', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px dashed var(--crm-table-row-border)' }}>
          <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{total.name}</span>
          <strong style={{ flexShrink: 0, color: total.quantity < 0 ? 'var(--crm-danger)' : 'var(--crm-success)' }}>
            {total.quantity > 0 ? '+' : ''}{total.quantity.toFixed(3)} {total.unit}
          </strong>
        </div>
      ))}
    </section>
  );
}
